import * as api from "../../shared/api";
import * as biz_data_helper from "../../shared/biz_data_helper";

const content_type = "sApproveTypeSetting";

const create = function () {
  return {
    content_type: "muji"
  };
};

const fields = [{
  key: "id",
  label: "编号",
  type: "button",
  button: {
    type: "text"
  },
  thStyle: {
    width: "60px"
  }
},
{
  key: "DocumentType",
  label: "类型名称",
  sortable: true
},
{
  key: "ApproveType",
  label: "审批类型",
  sortable: true
},
{
  key: "ApproveLevel",
  label: "审批等级",
  sortable: true
},
{
  key: "is_approved",
  label: "审批状态",
  type: "boolean",
  thStyle: {
    display: "none"
  },
  tdClass: "no-shown-RetailVariantId"
},
{
  key: "description",
  label: "备注",
  sortable: true
},
];

const dataForm = {
  id: 0,
  DocumentType: "",
  ApproveType: "",
  ApproveLevel: 1,
  description: "",
};

///前端验证
const rules = {
  DocumentType: [{
    required: true,
    message: "请输入类型名称",
    trigger: "blur"
  }],
  ApproveLevel: [{
    required: true,
    message: "请输入审批等级",
    trigger: "blur"
  }],
};

const descriptor = {};

const methods = {

  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields, "key")
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  ///update
  async upData(_data) {
    let datas = _data.selected_items;

    let _actions = [];
    switch (_data.state) {
      case "approved":
        //启用
        for (var i in datas) {
          datas[i].is_approved = true;
        }
        break;
      case "unapproved":
        for (var i in datas) {
          datas[i].is_approved = false;
        }
        //禁用
        break;
      default:
        break;
    }
    if (datas.length > 0) {
      _.each(datas, t => {
        let _data1 = {};
        if (_data.state) {
          if (_data.state == "approved" || _data.state == "unapproved") {
            _data1.id = t.id;
            _data1.is_approved = _data.state == "approved" ? true : false;
            _actions.push(
              biz_data
                .approveAction({
                  params: _data1,
                  fields: _.map(fields, "key")
                })
                .action({})
            );
          }
        } else {
          if (t.id == 0) {
            _data1.DocumentType = t.DocumentType;
            _data1.ApproveType = t.ApproveType;
            _data1.ApproveLevel = t.ApproveLevel;
            _data1.description = t.description;
            _actions.push(
              biz_data
                .insertAction({
                  params: _data1,
                  fields: _.map(fields, "key")
                })
                .action({})
            );
          } else {
            _data1.id = t.id;
            _data1.DocumentType = t.DocumentType;
            _data1.ApproveType = t.ApproveType;
            _data1.ApproveLevel = t.ApproveLevel;
            _data1.description = t.description;
            _actions.push(
              biz_data
                .updateAction({
                  params: _data1,
                  fields: _.map(fields, "key")
                })
                .action({})
            )
          }
        }
      });
      let result = await api.query_batch({
        actions: _actions
      });
      if (
        result &&
        result.data &&
        result.data.BatchResult &&
        result.data.BatchResult.Actions &&
        result.data.BatchResult.Actions.length > 0
      ) {
        return result.data.BatchResult.Actions;
      } else {
        return null;
      }
    }

  },

};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);
export {
  biz_data, dataForm, fields, methods,
  rules
};

